/**
 * Calculates the start and end indices of the currently visible window of dots.
 *
 * This is used to determine which dots are currently visible on the track.
 *
 * @param selectedIndex - The current slide index
 * @param totalSlides - Total number of slides in the carousel
 * @param visibleDots - Number of visible dots in the current window
 * @returns An object containing `startIndex` and `endIndex` of the visible dots
 */
export function getVisibleWindow(selectedIndex: number, totalSlides: number, visibleDots: number) {
    const startIndex = Math.min(Math.max(selectedIndex - Math.floor(visibleDots / 2), 0), totalSlides - visibleDots);
    const endIndex = startIndex + visibleDots - 1;
    return { startIndex, endIndex };
}
